import { createSlice } from "@reduxjs/toolkit";

const modalsSlice = createSlice({
    name: 'modals',
    initialState: {
        show: false,
        cart: false,
        moneyCart: {
            show: false,
            amount: 0
        },
        donators: false,
        addToCart: false,
        loading: true,
        data: {
            topDonatorsDescriptionImg: "",
            addToCartId: ""
        },
        promocodes: {
            show: false,
            list: []
        },
        voting: {
            show: false,
            data: {},
            points: 0,
            payLink: "",
            orderId: 0
        }
    },
    reducers: {
        showCartModal(state){
            state.cart = true;
            state.show = true;
        },
        showDonatorsModal(state){
            state.donators = true;
            state.show = true;
        },
        showLoadingModal(state){
            state.loading = true;
        },
        showAddToCartModal(state, data){
            state.addToCart = true;
            state.show = true;
            state.data.addToCartId = data.payload
        },
        showMoneyCartModal(state, data){
            state.moneyCart.show = true;
            state.moneyCart.amount = data.payload;
            state.show = true;
        },
        hideAllModals(state){
            state.show = false;
            state.cart = false;
            state.addToCart = false;
            state.donators = false;
            state.loading = false;
            state.rpmpass = false;
            state.moneyCart.show = false;
            state.moneyCart.amount = 0;
            state.promocodes.show = false;
            state.voting.show = false;
            state.voting.data = [];
            state.voting.points = 0;
            state.voting.orderId = 0;
            state.voting.payLink = "";
        },
        setTopDonatorsDescriptionImg(state, data){
            state.data.topDonatorsDescriptionImg = data.payload
        },
        showPromocodesModal(state, data){
            state.promocodes.show = true;
            state.promocodes.list = data.payload;
            state.show = true;
        },
        showCartVoting(state, data){
            state.voting.show = true;
            state.voting.data = data.payload.voting;
            state.voting.points = data.payload.points;
            state.voting.payLink = data.payload.paylink;
            state.voting.orderId = data.payload.order;
            state.show = true;
        }
    }
});

export const modalActions = modalsSlice.actions;
export default modalsSlice;